import { Eye } from "lucide-react";
import { Milestone } from "../../../../../Redux/referral/types";
import {
  earningsStatusClass,
  statusLabel,
} from "../../earningsAdapters";

interface Props {
  milestones: Milestone[];
  orderNo: string;
}

const NovaCommTeamTable = ({ milestones, orderNo }: Props) => {
  return (
    <div className="ri-table-wrap ri-nova-table-wrap">
      <table className="ri-table ri-nova-table">
        <thead>
          <tr>
            <th>MILESTONE</th>
            <th>CONTRIBUTION REQUIREMENT</th>
            <th>ACTIVE CONTRIBUTORS</th>
            <th>STATUS</th>
            <th>NETWORK VIEW</th>
          </tr>
        </thead>
        <tbody>
          {milestones?.map((milestone, index) => (
            <tr key={index}>
              <td className="ri-center">
                <strong>
                  {milestone.milestoneName ||
                    `Milestone - ${milestone.milestoneNo || index + 1}`}
                </strong>
              </td>
              <td className="ri-center">
                <strong>{milestone.contributionRequirement}</strong>
              </td>
              <td className="ri-center">
                <strong>{milestone.activeContributors}</strong>
              </td>
              <td className="ri-center">
                <span className={earningsStatusClass(milestone.status)}>
                  {statusLabel(milestone.status)}
                </span>
              </td>
              <td className="ri-center">
                <a
                  className="ri-view-button"
                  href={`/NovalLevelTeam?orderNo=${orderNo}&milestoneNo=${milestone.milestoneNo || index + 1}`}
                >
                  View
                  <Eye size={16} />
                </a>
              </td>
            </tr>
          ))}
          {(!milestones || milestones.length === 0) && (
            <tr>
              <td colSpan={5} className="ri-center">
                No milestone data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NovaCommTeamTable;
